module.exports = __webpack_public_path__ + "static/media/8OLA13.700e6a52.jpg";